var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultBaseEHRNote, } from './baseNoteSchema';
var defaultEmptyLateCancelNote = Object.freeze(__assign(__assign({}, defaultBaseEHRNote), { lateCancelDetails: '' }));
var prepareLateCancelNoteForSave = function (note) {
    var parsedNote = __assign({}, note);
    if (!parsedNote.cancellationReason) {
        delete parsedNote.cancellationReason;
    }
    return parsedNote;
};
export var lateCancelNoteSchemaInstance = {
    defaultValues: defaultEmptyLateCancelNote,
    useDeprecatedFields: function () { return []; },
    useDeprecatedValues: function () { return ({}); },
    prepareFormForSave: function (form) { return (__assign({}, prepareLateCancelNoteForSave(form.getValues()))); },
    prepareExistingNote: function (note) { return (__assign({}, note)); },
};
